import React from 'react';
import "./layout.css";
import '../styles/semantic.min.css';

export default ({ children }) => <div>{children}</div>